module.exports = __webpack_public_path__ + "img/service-tongyizhifu1.ab76e79d.svg";